import React, { useCallback, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {useDetectOutsideClick} from "../../../../utils/useDetectOutsideClick";
import { UserThumbnails, CircleAddIcon } from '../../../../components';
import { assigned_userActions } from '../../../../actions';
import { Button, Image } from 'react-bootstrap';
import DropdownIcon from '../../../../images/icons/dropdown-arrow.svg';
import { CONTENT_GROUP_PARTICIPANTS } from '../../../../constants';

function ParticipantField(props) {
  const {
    can_access_assigned_user,
    assigned_users,
    workspace_id,
    content_group_id,
    minWidth = 200,
    canAddParticipants = true
  } = props;
  const dispatch = useDispatch();
  const { currentWorkSpace } = useSelector(state => state.work_space);

  const activeDropDownPopup = (id) => {
    if(id) {
      setIsActive(true);
    }else {
      setIsActive(false);
    }
  }

  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const [showMobilePopup, setShowMobilePopup] = useState(false);

  const handleOpenAssignedUserEditPopup = (id, fromList) =>{
    const callback = (id, status) => {
      activeDropDownPopup(id);
      setShowMobilePopup(true);
    }

    dispatch(assigned_userActions.newAssignedUser(workspace_id, id, callback));
  }

  const participantModalTarget = useRef(null);
  const openParticipantsModal = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if(!can_access_assigned_user){
      return;
    }

    const onSuccess = (response) => {
      const boundary = participantModalTarget.current?.getBoundingClientRect();

      console.log(boundary)

      dispatch({ type: CONTENT_GROUP_PARTICIPANTS.OPEN_PARTICIPANTS_MODAL, payload: { boundary, content_group_id: content_group_id } })
    }

    const params = {
      content_group_id: content_group_id,
      workspace_id,
      onSuccess
    }

    dispatch(assigned_userActions.newAssignedUserForPopup(params))
  }, [dispatch, content_group_id, workspace_id, participantModalTarget.current, can_access_assigned_user]);

  const handleClose = () => {
     setIsActive(false);
     setShowMobilePopup(false);
  }

  return (
    <div 
      style={{position: 'relative', width: 'fit-content', minWidth: minWidth}} 
      className="text-center m-auto"
      ref={participantModalTarget}
    >
      {(assigned_users?.length > 0) ?
          <div onClick={openParticipantsModal}>
            <UserThumbnails 
              users={assigned_users} 
              disable_users_info={true} 
              className={'cursor-pointer'} 
              openUserSummary={true}
              hoverableOnly={true}
              workspace_id={workspace_id}
              organization_id={currentWorkSpace?.organization_id}
            />
          </div>  
        :
          can_access_assigned_user && canAddParticipants &&
          <div
            className="cursor-pointer detail h-36px btn-dashed btn  btn empty inactive d-flex flex-column p-0"
            onClick={openParticipantsModal}
          >
            <Button 
              variant="transparent" 
              className='inline_button text-left' 
              size={'sm'}
              style={{ flex: 1 }}
            >
              Add Participants
            </Button>

            <Image src={DropdownIcon} height={'8'} width={'8'} className="dropdown-icon"/>
          </div>
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.content_group.loading
  };
};

export default connect(mapStateToProps, {})(ParticipantField);
